var React = require('react');

function Vision (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9,2.64C5.19,2.64,1.86,5.13.08,8.83,1.85,12.53,5.19,15,9,15s7.14-2.48,8.92-6.18C16.14,5.13,12.81,2.64,9,2.64ZM9,12a3.15,3.15,0,1,1,3.15-3.15A3.15,3.15,0,0,1,9,12Z"}));
}

Vision.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 18 18"};

module.exports = Vision;

Vision.default = Vision;
